<template>
    <div class="row p-1">
        <div :class="{ 'col-md-6': quick_reports, 'col-md-12': !quick_reports }">
            <label>Checklist :</label> {{ checklist.name }} <br>
            <label>{{ $t('checklist.attribute.organization') }} : </label> {{ checklist.organization ?
            checklist.organization.name : '' }} <br>
            <span v-if="checklist.starting_date"><label for="">{{ $t('checklist.attribute.starting_date') }} : </label>
                {{ $moment(checklist.starting_date).format('D-M-Y') }}<br></span>
            <span v-if="checklist.ending_date"><label for=""
                    v-if="checklist.ending_date">{{ $t('checklist.attribute.ending_date') }} : </label>
                {{ $moment(checklist.ending_date).format('D-M-Y') }}<br></span>
            <span v-if="checklist.start_corrective_date"><label for=""
                    v-if="checklist.start_corrective_date">{{ $t('checklist.attribute.start_correctived_at') }}
                    : </label> {{ $moment(checklist.start_corrective_date).format('D-M-Y') }}<br></span>
            <span v-if="checklist.end_corrective_date"><label for=""
                    v-if="checklist.end_corrective_date">{{ $t('checklist.attribute.end_correctived_at') }} : </label>
                {{ $moment(checklist.end_corrective_date).format('D-M-Y') }}<br></span>
            <span v-if="checklist.closing_date"><label for=""
                    v-if="checklist.closing_date">{{ $t('checklist.attribute.closing_date') }} :</label>
                {{ $moment(checklist.closing_date).format('D-M-Y') }}<br></span>
            <label for="">{{ $t('checklist.attribute.status') }} : <a href="#">{{ checklist.status ? checklist.status.name
            : '' }}</a></label><br>
            <div v-for="(group, key) in team" :key="key">
                <label for="">{{ key }}:</label>
                <div class="table-responsive">
                    <table class="table table-hover table-striped">
                        <thead class="thead-light">
                            <tr>
                                <th>{{ $t('user.attribute.avatar') }}</th>
                                <th>{{ $t('user.attribute.organization') }}</th>
                                <th>{{ $t('user.attribute.position') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(user, key) in group" :key="key">
                                <td>
                                    <div class="avatar">
                                        <img class="img-avatar" :src="user.avatar" alt="" />
                                    </div>
                                </td>
                                <td>
                                    <div>{{ user.name }}</div>
                                    <div class="small text-muted">
                                        {{ user.email }}
                                    </div>
                                </td>
                                <td>{{ user.pos_name }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="col-md-6" v-if="quick_reports">
            <div class="table-responsive">
                <table class="table table-hover table-striped">
                    <thead class="thead-light">
                        <tr class="text-center">
                            <th>{{ $t('checklist.report.status') }}</th>
                            <th>{{ $t('checklist.report.number_of_questions') }}</th>
                            <th>{{ $t('checklist.report.point') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="text-center" v-for="(report, key) in quick_reports" :key="key">
                            <td>{{ report.code }}</td>
                            <td>{{ report.total }}</td>
                            <td>{{ report.point }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="data && labels && backgroundColor">
                <pie-chart :data="data" :labels="labels" :backgroundColor="backgroundColor"></pie-chart>
            </div>
        </div>
    </div>
</template>
<script>
import PieChart from '@/components/charts/PieExample'
import { mapGetters } from 'vuex'
export default {
  name: 'OverviewChk',
  components: { PieChart },
  props: ['checklist', 'quick_reports', 'team'],
  data () {
    return {
      loading: true
    }
  },
  computed: {
    ...mapGetters({
      labels: 'Audit/getLabelQuickReport',
      data: 'Audit/getDataQuickReport',
      backgroundColor: 'Audit/getBackgroundColorQuickReport'
    })
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style lang="scss">
label {
    font-weight: 700
}
</style>



// WEBPACK FOOTER //
// src/views/checklist/view/overviewChk.vue